/* global ig */

document.addEventListener('DOMContentLoaded', () => {
    const feedElement = document.getElementById('instagram-feed');
    const showFeed = () => {
        setTimeout(() => {
            feedElement.classList.add('feed-ready');
        }, 400);
    };

    if (feedElement && typeof ig !== 'undefined') {
        showFeed();
    }
    // if (feedElement && typeof ig !== 'undefined') {
    //     const imagesToLoad = 4;
    //     let imagesLoaded = 0;
    //     const template = `<li class="instafeed-block">
	// 								<a class="instagram-post-link image-{{orientation}}"
    //                                    style="background-image: url('{{image}}');"
	// 								   href="{{link}}"
	// 								   target="_blank"
	// 								   rel="noopener">
	// 								    <img src="{{image}}" />
	// 								</a>
    //                             </li>`;

    //     /*
    //      * ig includes the following:
    //      * at: the access token
    //      * will add hashtag later to filter images by tag
    //      * ht: hashtag
    //      */
    //     const instagramUserOptions = ig;
    //     const instagramFeedOptions = {
    //         accessToken: instagramUserOptions.at,
    //         target: feedElement,
    //         limit: imagesToLoad,
    //         apiTimeout: 5000,
    //         template: template,
    //         after: () => showFeed()
    //     };

    //     let filter = ig.ht;
    //     if (typeof filter !== 'undefined' && filter.length > 3) {
    //         // we are looking for images with specific hashtag
    //         // so we need to implement pagination for faster
    //         // results
    //         const pagination = 10;
    //         instagramFeedOptions.limit = pagination;

    //         instagramFeedOptions.filter = (image) => {
    //             if (image.tags.indexOf(filter) >= 0 && imagesLoaded < imagesToLoad) {
    //                 imagesLoaded += 1;
    //                 return true;
    //             }
    //             return false;
    //         };
    //         instagramFeedOptions.after = function () {
    //             if (imagesLoaded < imagesToLoad && this.hasNext()) {
    //                 this.next();
    //             } else {
    //                 showFeed();
    //             }
    //         };
    //     }

    //     const feed = new Instafeed(instagramFeedOptions);
    //     feed.run();
    // }
});